import { APICall } from ".";

export const ax_warranty_getAllWarranty = async (
  currentPage,
  searchQuery,
  itemsPerPage,
  createdFromBrand,
  startDate,
  endDate
) => {
  try {
    const res = await APICall.post(`/form/getWarranty`, {
      currentPage,
      searchQuery,
      itemsPerPage,
      createdFromBrand,
      startDate,
      endDate,
    });
    console.log("startDate - ", startDate);
    console.log("endDate - ", endDate);
    // console.log("searchQuery - ", searchQuery);
    // console.log("itemsPerPage - ", itemsPerPage);
    // console.log("res - " + JSON.stringify(res.data.data.length));

    if (res.data.code === 200) {
      return res.data;
    } else if (!res.data.success) {
      return res.data;
    }
    return null;
  } catch (e) {
    console.error("Error while fetching warranties: " + e);
    return null;
  }
  // } catch (e) {
  //   console.log("e.message:", e.response ? e.response.data : e.message);
  //   console.error("Error while fetching warraties: " + e);
  //   if (
  //     e.response?.data.code !== 200 ||
  //     e.response?.data.code !== 201 ||
  //     e.response?.data.code !== 409
  //   )
  //     return e.response;
  //   else return null;
  // }
};

export const ax_warranty_updateWarranty = async (_id, payload) => {
  try {
    const res = await APICall.put(`/form/${_id}`, payload);
    console.log("_id - ", _id);
    // console.log("payload - ", JSON.stringify(payload));
    console.log("res - " + JSON.stringify(res));

    if (res.data.code === 200) {
      return res.data;
    } else if (!res.data.success) {
      return res.data;
    }
    return null;
  } catch (e) {
    console.log("Error while updating warranty: " + JSON.stringify(e));
    console.error("Error while updating warranty: " + e);
    return null;
  }
  // } catch (e) {
  //   console.log("e.message:", e.response ? e.response.data : e.message);
  //   console.error("Error while fetching warraties: " + e);
  //   if (
  //     e.response?.data.code !== 200 ||
  //     e.response?.data.code !== 201 ||
  //     e.response?.data.code !== 409
  //   )
  //     return e.response;
  //   else return null;
  // }
};

export const ax_warranty_getInvoiceFile = async (_id) => {
  try {
    const res = await APICall.post(`/form/getInvoiceFile/${_id}`);
    console.log("_id - ", _id);

    if (res.data.code === 200) {
      return res.data;
    } else if (!res.data.success) {
      return res.data;
    }
    return null;
  } catch (e) {
    console.error("Error while fetching warranties: " + e);
    return null;
  }
};
